import { Grid } from '@mui/material';

import useDashboardDownload from 'hooks/useDashboardDownload';
import { CuredApiPaths, DashboardNames, DownloadQueryKeys, ApiMethods } from 'models/enums';
import { CONTACTS_CSV_FILES } from 'pages/InsightsPage/dashboards/dashboardCsvFileNames';
import DashboardDownloadDialog from 'pages/InsightsPage/dashboards/DashboardDownloadDialog';
import DashboardDownloadSnackbar from 'pages/InsightsPage/dashboards/DashboardDownloadSnackbar';

import DashboardHeader from '../DashboardHeader';

import AgeCard from './cards/AgeCard';
import ContactsCard from './cards/ContactsCard';
import DomainsCard from './cards/DomainsCard';
import LocationCard from './cards/LocationCard';
import SexCard from './cards/SexCard';
import SubscribersOverTimeCard from './cards/SubscribersOverTimeCard';
import SubscriptionStatusCard from './cards/SubscriptionStatusCard';
import UnsubscribesCard from './cards/UnsubscribesCard';

const ContactsDashboard = () => {
    const {
        handleDownloadClick,
        isDialogOpen,
        onDialogClose,
        onDownloadAll,
        onDownloadFile,
        isDownloading,
        currentFilename,
        isSuccess,
        error,
        resetDownloadState,
        csvFilenames,
    } = useDashboardDownload({
        queryKey: DownloadQueryKeys.CONTACTS_DASHBOARD,
        path: CuredApiPaths.REPORT_CONTACTS_DOWNLOAD,
        requestMethod: ApiMethods.GET,
        csvFilenames: CONTACTS_CSV_FILES,
        filtersForApi: {},
    });

    return (
        <div style={{ paddingBottom: '32px' }}>
            <DashboardDownloadSnackbar
                isDownloading={isDownloading}
                isSuccess={isSuccess}
                error={error}
                dashboardName={DashboardNames.CONTACTS}
                onSuccessClosed={resetDownloadState}
                onErrorClosed={resetDownloadState}
            />
            <DashboardDownloadDialog
                isOpen={isDialogOpen}
                onClose={onDialogClose}
                onDownloadAll={onDownloadAll}
                onDownloadFile={onDownloadFile}
                filenames={csvFilenames}
                isDownloading={isDownloading}
                currentFilename={currentFilename}
            />
            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <DashboardHeader
                        title="contacts"
                        subtitle="build unparalleled relationships"
                        description="Learn more about your contacts and monitor trends to target the right groups with relevant content."
                        handleDownloadClick={handleDownloadClick}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <ContactsCard />
                </Grid>
                <Grid item xs={12} md={8}>
                    <SubscribersOverTimeCard />
                </Grid>
                <Grid item xs={12} md={4}>
                    <SubscriptionStatusCard />
                </Grid>
                <Grid item xs={12} md={8}>
                    <UnsubscribesCard />
                </Grid>
                <Grid item xs={12} md={4}>
                    <DomainsCard />
                </Grid>
                <Grid item xs={12}>
                    <LocationCard />
                </Grid>
                <Grid item xs={12} md={8}>
                    <AgeCard />
                </Grid>
                <Grid item xs={12} md={4}>
                    <SexCard />
                </Grid>
            </Grid>
        </div>
    );
};

export default ContactsDashboard;
